const COMPARE_MODAL_TRANSITION_DURATION = 300;

class CompareModal extends ModalBase {
  get modalTransition() {
    return {
      overlayOpenClasses: ['opacity-100'],
      overlayClosedClasses: ['opacity-0'],
      panelOpenClasses: ['opacity-100', 'max-lg:translate-y-0', 'lg:scale-100'],
      panelClosedClasses: ['opacity-0', 'max-lg:translate-y-full', 'lg:scale-95'],
      transitionDuration: COMPARE_MODAL_TRANSITION_DURATION,
    };
  }

  constructor() {
    super();
    this.previousActiveElement = null;
    this.isOpen = false;
    this.focusTrapHandler = null;
    this.currentVariantId = null;
    this.selectedCardEl = null;
    this.unsubscribeVariant = null;
  }

  connectedCallback() {
    this.overlay = this.querySelector('[data-compare-price-overlay]');
    this.panel = this.querySelector('[data-compare-price-panel]');
    this.productForm = this.querySelector('product-form');
    this.form = this.productForm?.querySelector('[data-product-form]');
    this.hiddenIdInput = this.form?.querySelector('input[name="id"]');
    this.submitButton = this.form?.querySelector('[type="submit"]');
    this.cardsEl = this.querySelector('[data-compare-price-cards]');

    this.currentVariantId = this.dataset.initialVariantId;

    this.overlay?.addEventListener('click', () => this.close());

    this.addEventListener('click', (event) => {
      if (event.target.closest('[data-compare-price-cancel]')) this.close();
    });

    this.addEventListener('click', (event) => {
      const card = event.target.closest('[data-compare-price-card]');
      if (!card) return;
      this.selectCard(card);
    });

    this.handleKeydown = (event) => {
      if (event.key === 'Escape' && this.isOpen) this.close();
    };
    document.addEventListener('keydown', this.handleKeydown);

    this.handleTriggerClick = (event) => {
      if (event.target.closest('[data-compare-price-trigger]')) {
        event.preventDefault();
        this.open();
      }
    };
    document.addEventListener('click', this.handleTriggerClick);

    this.form?.addEventListener('submit', () => this.close());

    this.initVariantSubscriber();
  }

  disconnectedCallback() {
    this.unsubscribeVariant?.();
    document.removeEventListener('keydown', this.handleKeydown);
    document.removeEventListener('click', this.handleTriggerClick);
    this.removeTrapFocus();
  }

  initVariantSubscriber() {
    if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') return;

    this.unsubscribeVariant = subscribe(PUB_SUB_EVENTS.variantChange, (data) => {
      if (String(data.productId) !== this.dataset.productId) return;
      if (data.variant) this.currentVariantId = String(data.variant.id);
    });
  }

  open() {
    this.openModal(() => {
      this.resetSelection(this.currentVariantId);
    });
  }

  close() {
    this.closeModal();
  }

  selectCard(card) {
    this.currentVariantId = card.dataset.variantId;
    this.applySelection(card);
  }

  resetSelection(variantId) {
    const cards = [...this.querySelectorAll('[data-compare-price-card]')];
    const matchedCard = cards.find((card) => card.dataset.variantId === variantId) ?? cards[0];
    if (matchedCard) this.applySelection(matchedCard);
  }

  applySelection(card) {
    if (this.selectedCardEl && this.selectedCardEl !== card) {
      this.selectedCardEl.classList.remove('border-ink');
      this.selectedCardEl.classList.add('border-bg-grey');
      this.selectedCardEl.setAttribute('aria-pressed', 'false');
    }

    card.classList.remove('border-bg-grey');
    card.classList.add('border-ink');
    card.setAttribute('aria-pressed', 'true');
    this.selectedCardEl = card;

    const { variantId, available } = card.dataset;
    const isAvailable = available !== 'false';

    if (this.hiddenIdInput) this.hiddenIdInput.value = variantId;

    const buttonText = this.submitButton?.querySelector('[data-button-text]');
    if (this.submitButton && buttonText) {
      this.submitButton.disabled = !isAvailable;
      buttonText.textContent = isAvailable
        ? (window.theme?.strings?.addToCart ?? 'Add to cart')
        : (window.theme?.strings?.soldOut ?? 'Sold out');
    }
  }
}

if (!customElements.get('compare-price-modal')) {
  customElements.define('compare-price-modal', CompareModal);
}
